import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Card,
  CardHeader,
  CardContent,
  Box,
  Typography,
  Pagination,
} from "@mui/material";
import { QueueMusic } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import { rowOnEachPage } from "../../../configs/pagination.configs";

const PlaylistsTable = () => {
  const { listPlaylists } = useSelector((state) => state.statsData);

  const rowPerPage = rowOnEachPage.artistTable;
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [displayListPlaylists, setDisplayListPlaylists] = useState([]);

  useEffect(() => {
    const newTotalPages = Math.ceil(listPlaylists.length / rowPerPage) || 0;
    setTotalPages(newTotalPages);

    const startIndex = (currentPage - 1) * rowPerPage;

    const displayList =
      listPlaylists.slice(startIndex, startIndex + rowPerPage) || [];
    setDisplayListPlaylists(displayList);
  }, [currentPage, listPlaylists]);

  return (
    <Card>
      <CardHeader
        title={
          <Box display="flex" alignItems="center" gap={1}>
            <QueueMusic sx={{ color: "green" }} fontSize="small" />
            <Typography variant="h6">Playlists</Typography>
          </Box>
        }
        subheader="Manage your playlists"
      />
      <CardContent>
        <TableContainer
          component={Paper}
          sx={{
            maxHeight: { xs: 300, md: 250, lg: 500 },
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              width: "6px",
              height: "6px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "primary.main",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ color: "primary.main" }}>#</TableCell>
                <TableCell sx={{ color: "primary.main" }}>Playlist</TableCell>
                <TableCell sx={{ color: "primary.main" }}>Username</TableCell>
                <TableCell sx={{ color: "primary.main" }}>Created At</TableCell>
                <TableCell sx={{ color: "primary.main" }}>
                  Total songs
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {displayListPlaylists.map((playlist) => (
                <TableRow key={playlist.id}>
                  <TableCell>{playlist.id}</TableCell>
                  <TableCell>{playlist.name}</TableCell>
                  <TableCell>{playlist.username}</TableCell>
                  <TableCell>{playlist.createdAt.split("T")[0]}</TableCell>
                  <TableCell>{playlist.songCount}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {listPlaylists.length > 0 && (
          <Box display="flex" justifyContent="center" mt={3}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={(event, value) => setCurrentPage(value)}
              color="primary"
            />
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default PlaylistsTable;
